import React, { useState, useCallback, useEffect } from 'react';
import Helmet from 'react-helmet';
import { useApolloClient } from 'react-apollo';
import { useSelector } from 'react-redux';
import { GET_GROUP } from 'graphql/groups';
import { ROLES } from 'constant/userTypes';
import Lobby from './Lobby';
import Room from './Room';
import apiClient from '../../utils/api-client';
import MeetingDoneModal from "./MeetingDoneModal";
import CheckMeetingTypeModal from './CheckMeetingTypeModal';

const VideoChat = ({ match, isGroup, ...rest }) => {
  const roomName = match.params.roomId;
  const user = useSelector((s) => s.user.user);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [showDoneModal, setShowDoneModal] = useState(false);
  const [group, setGroup] = useState();
  const [settings, setSettings] = useState();
  const apolloClient = useApolloClient();
  const [isMeetingType, setIsMeetingType] = useState(false);
  const feedbackElement =
    document &&
    document.getElementById('appzi-launch-button-c1bb682c-6102-401d-a387-eb16c06f613f')



  useEffect(() => {
    if (isGroup) {
      apolloClient
        .query({
          query: GET_GROUP,
          variables: { id: roomName },
        })
        .then((resp) => {
          const { data } = resp;
          setGroup(data.group);
        });
    }
  }, []);

  useEffect(() => {
    try {
      const s = localStorage.getItem('deviceSettings');
      if (s) {
        setSettings(JSON.parse(s));
      }
    } catch (e) {
      console.log(e);
    }
  }, []);



  const onSaveSettings = (s) => {
    try {
      localStorage.setItem('deviceSettings', JSON.stringify(s));
      setSettings(s);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSubmit = useCallback(async (event) => {
    event.preventDefault();
    setLoading(true);
    const data = await apiClient.post('/twilio/video/token', {
      room: roomName,
      isGroup,
    });
    if (feedbackElement) feedbackElement.style.visibility = 'hidden';
    setToken(data.token);
    setLoading(false);
  }, []);

  const handleLogout = useCallback((event) => {
    if (feedbackElement) feedbackElement.style.visibility = 'visible';
    setToken(null);
    if ([ROLES.HC, ROLES.FA].includes(user.type)) {
      setShowDoneModal(true);
    }
    if ([ROLES.LC].includes(user.type)) {
      setIsMeetingType(true)
    }
  }, []);


  let render;
  if (token) {
    render = (
      <Room
        settings={settings}
        roomName={roomName}
        token={token}
        handleLogout={handleLogout} />
    );
  } else {
    render = (
      <Lobby
        isGroup={isGroup}
        group={group}
        settings={settings}
        loading={loading}
        handleSubmit={handleSubmit}
        onSaveSettings={onSaveSettings}
      />
    );
  }
  return (
    <React.Fragment>
      <Helmet title="Video Call" />
      {render}
      {isMeetingType && < CheckMeetingTypeModal setShowDoneModal={setShowDoneModal} />

      }
      {showDoneModal && (
        <MeetingDoneModal onClose={() => setShowDoneModal(false)} />
      )}
    </React.Fragment>
  );
};

export default VideoChat;
